import React from 'react'

const Error = ({ error }) => {
  return <div className='alert alert-danger'>{error}</div>
}

export default Error
